//import * as React from 'react';


export const countries = [
    "SINGAPORE",
    "MALAYSIA",
    "AFGHANISTAN",
    "ALAND ISLANDS",
    "ALBANIA",
    "ALGERIA",
    "AMERICAN SAMOA",
    "ANDORRA",
    "ANGOLA",
    "ANGUILLA",
    "ANTARCTICA",
    "ANTIGUA AND BARBUDA",
    "ARGENTINA",
    "ARMENIA",
    "ARUBA",
    "AUSTRALIA",
    "AUSTRIA",
    "AZERBAIJAN",
    "BAHAMAS",
    "BAHRAIN",
    "BANGLADESH",
    "BARBADOS",
    "BELARUS",
    "BELGIUM",
    "BELIZE",
    "BENIN",
    "BERMUDA",
    "BHUTAN",
    "BOLIVIA",
    "BOSNIA-HERZEGOVINA",
    "BOTSWANA",
    "BOUVET ISLAND",
    "BRAZIL",
    "BRITISH INDIAN OCEAN TERRITORY",
    "BRUNEI DARUSSALAM",
    "BULGARIA",
    "BURKINA FASO",
    "BURUNDI",
    "CAMBODIA",
    "CAMERON",
    "CANADA",
    "CAPE VERDE",
    "CARRIBBEAN NETHERLANDS",
    "CAYMAN IS",
    "CENTRAL AFRICAN REP",
    "CHAD",
    "CHILE",
    "CHINA",
    "CHRISTMAS IS",
    "COCOS (KEELING) ISLANDS",
    "COLOMBIA",
    "COMOROS",
    "CONGO",
    "COOK IS",
    "COSTA RICA",
    "COTE D'IVOIRE (IVORY COAST)",
    "CROATIA",
    "CUBA",
    "CURACAO",
    "CYPRUS",
    "CZECH REPUBLIC",
    "DENMARK",
    "DJIBOUTI",
    "DOMINICA",
    "DOMINICAN REPUBLIC",
    "EAST TIMOR",
    "ECUADOR",
    "EGYPT",
    "EL SALVADOR",
    "EQUATORIAL GUINEA",
    "ERITREA",
    "ESTONIA",
    "ETHIOPIA",
    "FALKLAND ISLANDS (MALVINAS)",
    "FAROE ISLANDS",
    "FIJI",
    "FINLAND",
    "FRANCE",
    "FRENCH GUIANA",
    "FRENCH POLYNESIA",
    "FRENCH SOUTHERN TERRITORIES",
    "GABON",
    "GAMBIA",
    "GEORGIA",
    "GERMANY",
    "GHANA",
    "GIBRALTAR",
    "GREECE",
    "GREENLAND",
    "GRENADA",
    "GUADELOUPE",
    "GUAM",
    "GUATEMALA",
    "GUERNSEY",
    "GUINEA",
    "GUINEA-BISSAU",
    "GUYANA",
    "HAITI",
    "HEARD AND MCDONALD ISLASNDS",
    "HOLY SEE (VATICAN CITY STATE)",
    "HONDURAS",
    "HONGKONG",
    "HUNGARY",
    "ICELAND",
    "INDIA",
    "INDONESIA",
    "IRAN, ISLAMIC REPUBLIC OF",
    "IRAQ",
    "IRELAND",
    "ISLE OF MAN",
    "ISRAEL",
    "ITALY",
    "JAMAICA",
    "JAPAN",
    "JERSEY",
    "JERSEY",
    "JORDAN",
    "KAZAKHSTAN",
    "KAZAKHSTAN",
    "KENYA",
    "KIRIBATI",
    "KOREA, DEMOCRATIC PEOPLE REPUBLIC OF (NORTH)",
    "KOREA, REPUBLIC OF",
    "KOSOVO",
    "KUWAIT",
    "KYRGYZSTAN",
    "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
    "LATVIA",
    "LEBANON",
    "LESOTHO",
    "LIBERIA",
    "LIBYAN ARAB JAMAHIRIYA",
    "LIECHSTENSTEIN",
    "LITHUANIA",
    "LUXEMBOURG",
    "MACAO",
    "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF",
    "MADAGASCAR",
    "MALAWI",
    "MALDIVES",
    "MALI",
    "MALTA",
    "MARSHALL IS",
    "MARTINIQUE",
    "MAURITANIA",
    "MAURITIUS",
    "MAYOTTE",
    "MEXICO",
    "MICRONESIA, FEDERATED STATES OF",
    "MOLDOVA, REPUBLIC OF",
    "MONACO",
    "MONGOLIA",
    "MONTENEGRO",
    "MONTSERRAT",
    "MOROCCO",
    "MOZAMBIQUE",
    "MYANMAR (BURMA)",
    "MYANMAR",
    "NAMIBIA",
    "NAURU",
    "NEPAL",
    "NETHERLANDS ANTILLES",
    "NETHERLANDS",
    "NEW CALEDONIA",
    "NEW ZEALAND",
    "NICARAGUA",
    "NIGER",
    "NIGERIA",
    "NIUE",
    "NORFOLK ISLAND",
    "NORTHERN MARIANA IS",
    "NORWAY",
    "OMAN",
    "ONGO, THE DEMOCRATIC REPUBLIC OF THE",
    "PAKISTAN",
    "PALAU",
    "PALESTINIAN TERRITORY, OCCUPIED",
    "PANAMA",
    "PAPUA NEW GUINEA",
    "PARAGUAY",
    "PERU",
    "PHILIPPINES",
    "PITCAIRN",
    "POLAND",
    "PORTUGAL",
    "PUERTO RICO",
    "QATAR",
    "REUNION",
    "ROMANIA",
    "RUSSIAN FEDERATION",
    "RWANDA",
    "SAINT BARTHÉLEMY",
    "SAINT KITTS-NEVIS",
    "SAINT LUCIA",
    "SAINT MARTIN",
    "SAINT PIERRE AND MIQUELON",
    "SAINT VINCENT AND THE GRENADINES",
    "SAMOA",
    "SAN MARINO",
    "SAO TOME AND PRINCIPE",
    "SAUDI ARABIA",
    "SENEGAL",
    "SERBIA",
    "SEYCHELLES",
    "SIERRA LEONE",
    "SLOVAKIA",
    "SLOVENIA",
    "SOLOMAN IS",
    "SOMALIA",
    "SOUTH AFRICA",
    "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
    "SOUTH SUDAN",
    "SPAIN",
    "SRI LANKA",
    "ST HELENA",
    "STATELESS",
    "SUDAN",
    "SURINAME",
    "SVALBARD AND JAN MAYEN IS",
    "SWAZILAND",
    "SWEDEN",
    "SWITZERLAND",
    "SYRIAN ARAB REPUBLIC (SYRIA)",
    "TAIWAN, PROVINCE OF CHINA",
    "TAJIKISTAN",
    "TANZANIA, UNITED REPUBLIC OF",
    "THAILAND",
    "TIMOR-LESTE",
    "TOGO",
    "TONGA",
    "TRINIDAD AND TOBAGO",
    "TUNISIA",
    "TURKEY",
    "TURKMENISTAN",
    "TURKS AND CAICOS IS",
    "TUVALU",
    "UGANDA",
    "UKRAINE",
    "UNITED ARAB EMIRATES",
    "UNITED KINGDOM",
    "UNITED STATES MINOR OUTLYING ISLANDS",
    "UNITED STATES OF AMERICA",
    "URUGUAY",
    "UZBEKISTAN",
    "VANUATU",
    "VENEZUELA",
    "VIET NAM",
    "VIRGIN ISLANDS (US)",
    "VIRGIN ISLANDS, BRITISH",
    "WALLIS AND FUTUNA",
    "WESTERN SAHARA",
    "YEMEN PEOPLE'S DEMOCRATIC REPUBLIC",
    "YEMEN",
    "YUGOSLAVIA",
    "ZAIRE",
    "ZAMBIA",
    "ZIMBABWE"    
];
export default countries